import React, { useEffect, useState, useRef } from "react";
import Popup from "reactjs-popup";
import SignaturePad from "react-signature-canvas";
import swal from "sweetalert";
import is_null from "./ObjectCheck";

const ModalPopup = (props) => {
  const sigCanvas = useRef(null);
  const close = props.close;
  const openVar = props.openVar;
  const msg = props.customMsg;
  const imageURL = props.imageURL;
  const setImageUrl = props.setImageUrl;
  const lang = props.lang;
  const key = props.uniqueKey;
  const type = props.type;
  const firstName = props.firstName;
  const lastName = props.lastName;
  const textLimit = props.textLimit;
  const canSubmit = props.canSubmit;
  const submit = props.submit;
  const fields = props.fields;
  let fontSize = 24;

  let [tab1, setTab1] = useState("");
  let [tab2, setTab2] = useState("hidden");

  let [selectTab1, setSelectedTab1] = useState("selectedTab");
  let [selectTab2, setSelectedTab2] = useState("unselectedTab");

  if (type === "textbox") {
    // set to text only because its input from keyboard only
    selectTab1 = "unselectedTab hidden";
    selectTab2 = "selectedTab";
    tab1 = "hidden";
    tab2 = "";
  }

  const [text, setText] = useState("");

  const typed = () => {
    const t = document.getElementById("textInput");
    if (!t) return;

    const img = document.getElementById("textImage");
    const ctx = document.getElementById("textCanvas").getContext("2d");

    // the image the text makes is too small by default for the certs
    // so we scale up the text when we make it
    // 3 seems to be a good scale, dont change this too much
    const scale = 2;
    const measure = ctx.measureText(text + " ");
    ctx.canvas.width = measure.width;
    ctx.canvas.height = Math.round(44 * scale);

    ctx.font = `${Math.round(40 * scale)}px 'monotype corsiva'`;
    ctx.fillText(text, 2 * scale, Math.round(32 * scale));
    img.src = ctx.canvas.toDataURL();

    const v = document.getElementById("textInput");
    if (v && text === "") v.value = "";
  };

  useEffect(typed, [text]);

  const clear = () => {
    sigCanvas.current.clear();
    setText("");
  };

  const save = (i) => {
    setImageUrl(i);
  };

  const submitButton = async () => {
    // We check to make sure that the signature exists
    // and also make sure the user puts something more than just a dot on the screen or a small line
    //using text instead of canvas

    const strokes = sigCanvas.current.toData();
    let max_id = props.maxId;
    let next_id = props.getNextId(fields);

    if (selectTab2 === "selectedTab" && text.length !== 0) {
      const image = document.getElementById("textImage");
      save(image.src); // add a space at the end to prevent cursive text clipping
      if (next_id !== max_id && next_id > -1) {
        document.location.hash = `loc${Number(next_id) + 1}`;
      }
      close(props.index);
      // text success
    } else if (
      selectTab1 === "selectedTab" &&
      !sigCanvas.current.isEmpty() &&
      strokes.length > 0 &&
      strokes[0].length > 9
    ) {
      save(sigCanvas.current.toDataURL(`image/png`));
      if (next_id !== max_id && next_id > -1) {
        document.location.hash = `loc${Number(next_id) + 1}`;
      }
      close(props.index);
      // signature success
    } else {
      await swal({ icon: "warning", title: "Invalid Signature", text: "Please fix, and try again." }).catch(
        (e) => { }
      );
      return;
    }

    clear();
    setTab1("");
    setTab2("hidden");
    setSelectedTab1("selectedTab");
    setSelectedTab2("unselectedTab");
    setText("");

    // make sure all fields are not empty
    if (!canSubmit(fields)) {
      return;
    }

    // adding a timeout here
    // when the enter key is pressed, itll auto submit too quickly,
    // so I force a delay here so it doesnt skip the popup
    setTimeout(async () => {
      await swal({
        icon: "success",
        title: lang.AllGoodToSubmit,
        buttons: {
          cancel: lang.GoBack,
          submit: {
            text: lang.Submit,
            value: "submit",
          },
        },
        text: lang.AllLocations,
      }).then(async (res) => {
        if (res === "submit") {
          await submit();
        }
      });
    }, 250);
  };

  return (
    <Popup
      modal
      closeOnDocumentClick={false}
      open={openVar}
      imageURL={imageURL}
    >
      <div className={props.customClass}>
        <h1>{msg}</h1>
        <p className={`sigText`}>{lang.MouseDraw}</p>

        <div className="tabbedMenu">
          <div
            className={`tabHeader ${selectTab1}`}
            onClick={(ref) => {
              setTab1("");
              setTab2("hidden");
              setSelectedTab1("selectedTab");
              setSelectedTab2("unselectedTab");
            }}
          >
            <a>{lang.Draw}</a>
          </div>
          <div
            className={`tabHeader ${selectTab2}`}
            onClick={(ref) => {
              setTab1("hidden");
              clear();
              setTab2("");
              setSelectedTab1("unselectedTab");
              setSelectedTab2("selectedTab");
              typed();
              const t = document.getElementById("textInput");
              if (!t) return;
              if (type === "initial") {
                if (firstName && lastName) {
                  let try_initial = firstName[0] + "." + lastName[0] + ".";
                  t.value = try_initial;
                  setText(try_initial);
                } else {
                  let a = firstName
                    .split(/\/| /)
                    .filter((f) => f != "")
                    .map((m) => m[0])
                    .join(".");
                  t.value = a;
                  setText(a);
                }
              }
              if (type === "signature") {
                t.value = firstName + " " + lastName;
                setText(firstName + " " + lastName);
              }
            }}
          >
            <a>{lang.Type}</a>
          </div>
          <div className={`tab ${tab1}`} id="canvasTab">
            <SignaturePad
              ref={sigCanvas}
              clearOnResize={false}
              dotSize={2}
              maxWidth={3}
              minDistance={3}
              canvasProps={{ className: "signatureCanvas" }}
            />
          </div>
          <div className={`tab ${tab2}`} id="typedTab">
            <input
              onChange={(text) => {
                setText(text.target.value);
              }}
              onKeyDown={async (e) => {
                if (e && e.key === "Enter") {
                  console.log("test");
                  await submitButton();
                }
              }}
              maxLength={textLimit}
              onKeyUp={() => {
                typed();
              }}
              type={"text"}
              id={"textInput"}
              className={`${type === "textbox" ? "normalfont" : "fancyfont"}`}
              name="textInput"
              placeholder="enter text here"
              style={{
                fontSize:
                  type === "textbox"
                    ? fontSize
                    : Math.max(75 * Math.pow(Math.E, -text.length / 30), 35),
              }}
            ></input>
            <canvas
              id="textCanvas"
              className="hidden"
              style={{ backgroundColor: "cyan" }}
            ></canvas>
            <img
              id="textImage"
              className="hidden"
              style={{ backgroundColor: "cyan" }}
            ></img>
          </div>
        </div>

        <p className="sigText">{lang.SubmitSignature}</p>

        <div
          style={{
            textAlign: "center",
          }}
        >
          <button
            className="subbtn"
            onClick={() => {
              close(props.index);
              setTab1("");
              setTab2("hidden");
              setSelectedTab1("selectedTab");
              setSelectedTab2("unselectedTab");
              setText("");
            }}
          >
            {lang.Close}
          </button>

          <button
            className="subbtn"
            onClick={() => {
              clear();
            }}
          >
            {lang.Clear}
          </button>

          <button className="subbtn" onClick={submitButton}>
            {lang.Submit}
          </button>
        </div>
      </div>
    </Popup>
  );
};
export default ModalPopup;
